var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7301 5.1443L11.6845 0H10.5391L7.15758 4.39938L3.7757 0H0L5.26955 6.85533L1.3148 12H2.46019L5.84207 7.60025L9.22429 12H13L7.7301 5.1443ZM1.86194 0.932509H3.34685L11.1377 11.0674H9.65279L1.86194 0.932509Z",
    fill: "#F0F0F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.4bbdd3905544f0acc3dd8a0b32564b77.svg";
export { ForwardRef as ReactComponent };